import React from 'react'
import './Skills.css'
import { SiJavascript } from 'react-icons/si';
import { SiReact } from 'react-icons/si';
import { SiHtml5 } from 'react-icons/si';
import { SiCss3 } from 'react-icons/si';
import { SiJest } from 'react-icons/si';
import { FaGitSquare } from 'react-icons/fa';
import { SiDocker } from 'react-icons/si';
import { GrMysql } from 'react-icons/gr';
import { SiNodedotjs } from 'react-icons/si';
import { SiExpress } from 'react-icons/si';
import { SiSequelize } from 'react-icons/si';
import { SiTypescript } from 'react-icons/si';


function Skills() {
  return (
    <section id="skills">
      <h3>Minhas</h3>
      <h2>Habilidades</h2>

      <div className="stacks">

        <div className='stack'>
          <span className="stack-title">Front-End</span>
          <div className="hard-skills">
            <span className="skill"><SiReact className="stack-icon"/>React.JS</span>
            <span className="skill"><SiJavascript className="stack-icon"/>Javascript</span>
            <span className="skill"><SiHtml5 className="stack-icon"/>HMTL</span>
            <span className="skill"><SiCss3 className="stack-icon"/>CSS</span>
            <span className="skill"><FaGitSquare className="stack-icon"/>Git</span>
            <span className="skill"><SiJest className="stack-icon"/>Jest</span>
          </div>
        </div>

        <div className='stack'>
          <span className="stack-title">Back-End</span>
          <div className="hard-skills">
            <span className="skill"><SiNodedotjs className="stack-icon"/> Node.JS</span>
            <span className="skill"><SiExpress className="stack-icon"/> Express</span>
            <span className="skill"><GrMysql className="stack-icon"/> MySQL</span>
            <span className="skill"><SiSequelize className="stack-icon"/> Sequelize</span>
            <span className="skill"><SiDocker className="stack-icon"/> Docker</span>
            <span className="skill"><SiTypescript className="stack-icon"/>Typescript</span>
          </div>
        </div>
      </div>

    </section>
  )
}

export default Skills;
